// Feature-Flags (Build-Zeit, REACT_APP_*).
//
// TIKTOK_VIDEO_ENABLED: Das TikTok-Video-Produkt (Upload/Publish) ist bei TikTok in
// Prüfung. Solange es aus ist, blendet das Frontend die TikTok-Upload/Publish-UI aus;
// das Backend erzwingt dasselbe (OAuth-Scope nur user.info.basic + 403 auf Video-Publish).
// Die TikTok-Konto-Verbindung selbst bleibt möglich.
// Wieder öffnen nach der Genehmigung: REACT_APP_TIKTOK_VIDEO_ENABLED=true (oder Zeile
// entfernen) + Frontend neu bauen; im Backend TIKTOK_VIDEO_ENABLED=true + Neustart.
export const TIKTOK_VIDEO_ENABLED =
  String(process.env.REACT_APP_TIKTOK_VIDEO_ENABLED || 'true').toLowerCase() !== 'false';

// TREND_RESEARCH_ENABLED: „Trends mit Perplexity analysieren" (Monatsplan-Karte).
// Default AUS (andere Polarität als TikTok, bewusst): Ohne PERPLEXITY_API_KEY liefert das
// Backend IMMER nur 6 hartkodierte Demo-Ideen zu 3 Themen (perplexity_trends._simulate_trends)
// — bei jedem anderen Thema themenfremd. Ein Mockup, das wie Recherche aussieht, ist für
// zahlende Kunden schlimmer als kein Feature. Wieder aktivieren erst, wenn (a) Key in .env,
// (b) Silent-Simulation-Fallback durch sichtbaren Fehler ersetzt, (c) workspace-Scoping in
// trend_to_post/perplexity_logs gefixt ist. Dann: REACT_APP_TREND_RESEARCH_ENABLED=true + Rebuild.
export const TREND_RESEARCH_ENABLED =
  String(process.env.REACT_APP_TREND_RESEARCH_ENABLED || 'false').toLowerCase() === 'true';

// QA_UI_ENABLED: „Alle Posts auf Qualität überprüfen" (Qualitäts-Panel im Monatsplan).
// Default AUS: Die Qualitätsprüfung läuft ab sofort automatisch serverseitig beim Erzeugen
// des Plans (autopilot/quality.py) — jeder Post ist bereits geprüft, bevor der Kunde ihn
// sieht. Ein Knopf, der dem Kunden dieselbe Prüfung noch einmal als AUFGABE zuweist, macht
// aus einem fertigen Ergebnis eine Hausaufgabe und untergräbt das Produktversprechen
// „Content auf Knopfdruck". Das Panel bleibt reines Innenwerkzeug (Diagnose bei Verdacht auf
// schlechte Generierung). Wieder einblenden — nur intern, z.B. auf einem Test-Workspace:
// REACT_APP_QA_UI_ENABLED=true + Frontend neu bauen.
export const QA_UI_ENABLED =
  String(process.env.REACT_APP_QA_UI_ENABLED || 'false').toLowerCase() === 'true';

// VIDEO_BATCH_ENABLED: „Für alle Posts Videos generieren" (20er-Batch im Monatsplan).
// Default AUS: Der Batch rendert synchron-sequenziell in EINEM HTTP-Request — 20 Videos
// ≈ >60 Minuten, Browser/Proxy kappen die Verbindung nach Minuten; der Lauf vom 22.07.
// produzierte 7 bezahlte fal.ai-Renders ohne ein einziges abgeholtes Video. Die
// EINZEL-Video-Generierung (VideoPage) bleibt an — der Poll-URL-Bug dahinter ist gefixt
// (video_providers._fal_requests_root). Batch erst nach Async-Umbau wieder aktivieren:
// REACT_APP_VIDEO_BATCH_ENABLED=true + Rebuild.
export const VIDEO_BATCH_ENABLED =
  String(process.env.REACT_APP_VIDEO_BATCH_ENABLED || 'false').toLowerCase() === 'true';
